import {useEffect, useState} from 'react';
import {BigNumber} from 'ethers';
import useBombFinance from './useBombFinance';
import useRefresh from './useRefresh';

const useTotalStakedOnBoardroom = () => {
  const [totalStaked, setTotalStaked] = useState(BigNumber.from(0));
  const bombFinance = useBombFinance();
  const {slowRefresh} = useRefresh();
  const isUnlocked = bombFinance?.isUnlocked;

  useEffect(() => {
    async function fetchTotalStaked() {
      try {
        setTotalStaked(await bombFinance.getTotalStakedInBoardroom());
      } catch (err) {
        console.error(err);
      }
    }
    fetchTotalStaked();
  }, [isUnlocked, slowRefresh, bombFinance]);

  return totalStaked;
};

export default useTotalStakedOnBoardroom;
